import { Notificacion } from '../../components/Util/Notificacion/Notificacion.jsx';
import { SiteRutas } from '../../request/RutasConfig.jsx';

export const manageError = (pData, { props }) => {
    let loginRequired = false;
    let errorText = "";
    switch (pData.CodigoError) {
        case 2:
            loginRequired = true;
            errorText = "Sesión Expiró";
            break;
        case 999:
            loginRequired = true;
            errorText = "Sesión Expiró";
            break;
        default:
            loginRequired = false;
            errorText = pData.Mensaje;
            break;
    }

    if (loginRequired) {
        Notification.error(errorText);
        props.history.push({
            pathname: SiteRutas.Login,
            state: { location: props.history.location }
        });
    }
    else {
        Notification.error(errorText);
    }
};